import { ShoppingCart, Store, Truck, FileText, PenTool, Megaphone, Package } from "lucide-react";

const modules = [
  {
    icon: ShoppingCart,
    title: "Comercio Electrónico",
    description: "Comprende los fundamentos, modelos y criterios para operar en el mundo digital.",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&auto=format&fit=crop&q=80",
  },
  {
    icon: Store,
    title: "Creación de Tienda",
    description: "Configura y estructura tu tienda online con enfoque práctico y orden.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&auto=format&fit=crop&q=80",
  },
  {
    icon: Truck,
    title: "Proveedores",
    description: "Desarrolla criterio para evaluar, seleccionar y negociar con proveedores.",
    image: "https://images.unsplash.com/photo-1631010231931-d2c396b444ec?w=600&auto=format&fit=crop&q=80",
  },
  {
    icon: FileText,
    title: "Página de Venta",
    description: "Estructura páginas claras que comuniquen valor y faciliten la decisión.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&auto=format&fit=crop&q=80",
  },
  {
    icon: PenTool,
    title: "Content Marketing",
    description: "Aplica principios de contenido para atraer y conectar con tu audiencia.",
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=600&auto=format&fit=crop&q=80",
  },
  {
    icon: Megaphone,
    title: "Marketing y Ads",
    description: "Comprende la lógica de campañas de pago y optimiza con criterio.",
    image: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=600&auto=format&fit=crop&q=80",
  },
  {
    icon: Package,
    title: "Gestión de Pedidos",
    description: "Organiza tu operación para gestionar pedidos con más claridad.",
    image: "https://images.unsplash.com/photo-1618381297523-e6c0ab13a5b2?w=600&auto=format&fit=crop&q=80",
  },
];

export default function AcademyContentSection() {
  return (
    <section
      data-testid="academy-content-section"
      className="py-20 md:py-28 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#0F3D56] mb-4 block">
            Estructura del programa
          </span>
          <h2
            className="text-3xl md:text-5xl font-semibold text-[#111827] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Qué incluye esta ruta
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            Una biblioteca de contenido organizada por temas clave del ecommerce. 
            Cada módulo está diseñado para que desarrolles criterio y avances de forma estructurada.
          </p>
        </div>

        {/* Modules Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {modules.map((module, index) => (
            <div
              key={index}
              data-testid={`module-card-${index}`}
              className="group bg-white border border-gray-200 overflow-hidden hover:shadow-xl hover:border-[#0F3D56]/20 transition-all duration-500"
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={module.image}
                  alt={module.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/60 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <div className="w-10 h-10 bg-white/90 backdrop-blur-sm flex items-center justify-center">
                    <module.icon size={20} className="text-[#0F3D56]" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-base font-bold text-[#111827] mb-2 group-hover:text-[#0F3D56] transition-colors">
                  {module.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {module.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            Programa educativo provisto por MINED. Todos los módulos incluyen clases grabadas y recursos de apoyo.
          </p>
        </div>
      </div>
    </section>
  );
}
